export default __webpack_public_path__ + "static/media/Cairo-Black.f6c9f5af.ttf";